import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import heroSmall from "../data/images/hero-small.png";
import VerificationCode from "../components/VerificationCode";
import { useStateContext } from "../contexts/ContextProvider";
import { verifyUser } from "../services/apiService";
import HeadMetaTags from "../components/HeadMetaTags";

const initialErrorState = {
  email: "",
  requestError: "",
};

const Login = () => {
  const { isLoggedIn } = useStateContext();
  const [showLogin, setShowLogin] = useState(true);
  const [requestCode, setRequestCode] = useState(false);
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(initialErrorState);
  const [apiError, setApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const roomId = searchParams.get("roomId");
  const inviteId = searchParams.get("id");

  const navigate = useNavigate();

  const handleChange = (event) => {
    const { value } = event.target;
    setEmail(value);
  };

  const resetEmail = () => {
    setEmail("");
    setErrorMessage("");
  };

  const handleContinue = async () => {
    setIsLoading(true);
    if (hasErrors()) {
      setIsLoading(false);
      return;
    } else {
      // const response =
      await verifyUser({ email });
      // if (response.hasError) {
      //   setIsLoading(false);
      //   setApiError(true);
      //   response.error.status === 404
      //     ? setErrorMessage("Error - Account does not exist.")
      //     : setErrorMessage(response.error.message);
      //   activateError("requestError");
      //   return;
      // } else {
      setShowLogin(!showLogin);
      setRequestCode(!requestCode);
      setIsLoading(false);
      // }
    }
  };

  const hasErrors = () => {
    const reg = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/); // valid email format?
    if (email === "" || !reg.test(email)) {
      activateError("email");
      return true;
    } else if (error.requestError !== "") {
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600 border-2",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <>
      <HeadMetaTags
        title="Login | Roommates Made Simple"
        ogTitle="Login | Roommates Made Simple"
      />
      <div className="fixed top-0 left-0 right-0">
        <div className="pl-3">
          <NavLink
            id="logo"
            to="/"
            className="text-snappily-orange text-center text-3xl"
          >
            <div className="flex items-center">
              <img
                src={heroSmall}
                alt="Snappily Logo"
                className="h-20 w-40 object-contain ml-1"
              />
            </div>
          </NavLink>
        </div>
        {showLogin && (
          <>
            <div className="flex justify-center text-3xl pt-10">
              {inviteId ? "Accept Invite" : "Log In"}
            </div>
            {inviteId && (
              <div className="flex justify-center text-center mt-5 px-10">
                Please enter the email where you received your invite.
              </div>
            )}
            <div className="grid justify-items-center">
              <div className="flex justify-center w-full py-5">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleContinue();
                  }}
                >
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    autoFocus={true}
                    value={email}
                    onClick={apiError ? resetEmail : () => {}}
                    onChange={handleChange}
                    className={`h-10 w-72 border-gray-300 border-1 rounded-md
                       focus:outline-snappily-orange px-5 ${error.email}`}
                  />
                </form>
              </div>
              <Button
                isDiabled={isLoading}
                background="bg-snappily-orange"
                text="text-white"
                opacity="bg-opacity-100"
                title="Continue"
                height="h-10"
                width="w-72"
                borderHover="hover:border-snappily-orange"
                customFunc={handleContinue}
              />
              <div className="text-sm text-gray-400 mt-5">
                Need an account?{" "}
                <span
                  className="text-snappily-orange cursor-pointer"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Sign up here
                </span>
              </div>
              {apiError && (
                <div className="flex justify-center h-10 mt-2 text-red-600">
                  {errorMessage}
                </div>
              )}
            </div>
          </>
        )}
        {requestCode && (
          <VerificationCode
            email={email}
            roomId={roomId}
            inviteId={inviteId || null}
          />
        )}

        {/* This is for logo screenshots -- Don't forget to delete
          <div className="flex justify-center mt-40">
            <div className="grid justify-items-center">
              <img
                src={heroSmall}
                alt="Snappily Logo"
                className="w-96 object-contain"
              />
              <div className="flex justify-center mt-1 pr-3 text-base text-snappily-orange">
                Find roommates, collect rent, split bills, and more!
              </div>
            </div>
          </div> */}
      </div>
    </>
  );
};

export default Login;
